import React, { Fragment, memo } from "react";
import "./LegendTooltip.css";

/* ##### CustomizeTooltip component is used To Customize Graph ToolTip  ##### */

const CustomizeTootip = ({
  active,
  payload,
  label,
  TooltipValues,
  showDataKey,
}) => {
  console.log("CustomizeTootip payload", payload);
  if (active && payload?.length) {
    return (
      <div className="custom-tooltip-container">
        <span style={{ fontWeight: "800" }}>{label}</span>
        {payload?.map((ele, index) => {
          console.log("payload ele", ele);
          return (
            <Fragment key={index}>
              {/* <small style={{ color: `${ele.color}` ,fontWeight:"800"}} > {showDataKey?ele?.dataKey: TooltipValues[index]} : {ele?.value===null || ele?.value===undefined || ele?.value===""? "N/A":ele?.value} </small> */}
              <small style={{ color: `${ele.color}`, fontWeight: "800" }}>
                {" "}
               {ele?.dataKey} :{" "}
              {/* {ele?.payload?.predicted && "Forecasted "} {ele?.dataKey} :{" "} */}
                {ele?.value === null ||
                ele?.value === undefined ||
                ele?.value === ""
                  ? "N/A"
                  : ele?.value}{" "} 
                  {/* : ele?.value}{" "} {ele?.dataKey === "Actual PR" && ele?.payload?.actual_gii ? `(GII (kWh/m^2): ${ele?.payload?.actual_gii})` : ""} */}
              </small>
            </Fragment>
          );
        })}
      </div>
    );
  } else return null;
};

export default memo(CustomizeTootip);
